import useAxios from 'hooks/useAxios';

export async function getAffiliateCodes() {
  const api = useAxios();

  try {
    const res = await api.get('/users/affiliate-codes');
    return res;
  } catch (err) {
    return err;
  }
}

